import { render } from "./code-default.vue?vue&type=template&id=6a454cd9"
import script from "./code-default.vue?vue&type=script&lang=js"
export * from "./code-default.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__